import { render, staticRenderFns } from "./form.vue?vue&type=template&id=24977360&scoped=true&lang=pug&"
import script from "./form.vue?vue&type=script&setup=true&lang=js&"
export * from "./form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=24977360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24977360",
  null
  
)

export default component.exports